var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.75V33.25M19 8.75C19 6.89348 18.2625 5.11301 16.9497 3.80025C15.637 2.4875 13.8565 1.75 12 1.75H3.25C2.78587 1.75 2.34075 1.93437 2.01256 2.26256C1.68437 2.59075 1.5 3.03587 1.5 3.5V26.25C1.5 26.7141 1.68437 27.1592 2.01256 27.4874C2.34075 27.8156 2.78587 28 3.25 28H13.75C15.1424 28 16.4777 28.5531 17.4623 29.5377C18.4469 30.5223 19 31.8576 19 33.25M19 8.75C19 6.89348 19.7375 5.11301 21.0503 3.80025C22.363 2.4875 24.1435 1.75 26 1.75H34.75C35.2141 1.75 35.6592 1.93437 35.9874 2.26256C36.3156 2.59075 36.5 3.03587 36.5 3.5V26.25C36.5 26.7141 36.3156 27.1592 35.9874 27.4874C35.6592 27.8156 35.2141 28 34.75 28H24.25C22.8576 28 21.5223 28.5531 20.5377 29.5377C19.5531 30.5223 19 31.8576 19 33.25",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenness);
export default __webpack_public_path__ + "static/media/openness.3b63349c797a1ba467ad091443611f76.svg";
export { ForwardRef as ReactComponent };